import { render, staticRenderFns } from "./CompanyDemoView.vue?vue&type=template&id=45573ca2"
import script from "./CompanyDemoView.vue?vue&type=script&lang=js"
export * from "./CompanyDemoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports